const buttonFormservQuesList = {
  text: 'Agregar Acción'
};

export default buttonFormservQuesList;
